.wrapper {
  display: flex;
  max-width: 100%;
  gap: 0.25em;
  white-space: nowrap;
}

/* It's just slightly taller then normal text. Line it up vertically. Flex box
 * did not work in this instance. */
aha-icon {
  position: relative;
  top: 1px;
}

:host(:hover[clickable]) {
  --aha-pill--fg-color: var(--theme-link-text);
  cursor: pointer;
}
